module.exports = __webpack_public_path__ + "static/img/banner.d407672c.png";